import axios from "axios";
import React, { Component } from "react";
import AsyncSelect from "react-select/async";
import { signInUser } from "../../Utility/Auth";
import customStyles from "./SelectFeild";

const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5001/api/";

// const dispatch = useDispatch();

class DamageNewProductSelect extends Component {
  constructor(props, context, dispatch) {
    super(props, context);
    this.state = {
      selectedOption: null,
      normalSelectOption: null,
      qString: null,
    };
  }
  result = [];
  cancelToken = null;
  searchProduct = async (e) => {};

  fetchData = async (inputValue, callback) => {
    const auth = signInUser();
    const aamarId = auth?.aamarId;
    const rawWh = this.props.warehouse || auth?.warehouse;
    const warehouse =
      rawWh && rawWh !== "undefined" && rawWh !== "null"
        ? typeof rawWh === "object"
          ? rawWh._id || rawWh.id
          : rawWh
        : "allWh";

    const trimmedInput = (inputValue || "").trim();
    if (!trimmedInput) {
      callback([]);
      return;
    }

    this.setState({ qString: trimmedInput });

    if (this.cancelToken) {
      this.cancelToken.cancel("Cancel The Previous Request");
    }
    this.cancelToken = axios.CancelToken.source();

    try {
      const baseUrl = BASE_URL.endsWith("/") ? BASE_URL : `${BASE_URL}/`;
      const query = encodeURIComponent(trimmedInput);
      const result = await axios.get(
        `${baseUrl}product/search/${aamarId}/${warehouse}/${query}`,
        {
          cancelToken: this.cancelToken.token,
        }
      );
      this.result = result;
      const products = Array.isArray(result?.data) ? result.data : [];

      let tempArray = [];
      if (
        products.length === 1 &&
        (products[0]?.article_code === trimmedInput ||
          products[0]?.ean === trimmedInput)
      ) {
        // Exact barcode match auto-add
        this.props.addToList(products[0], this.selectRef.current);
        this.setState({ selectedOption: null, qString: null });
        this.selectRef.current?.focus?.();
        callback([]);
        return;
      } else if (products.length > 0) {
        products.forEach((element) => {
          const mrp = element?.priceList?.[0]?.mrp ?? 0;
          tempArray.push({
            label: `${element.name} - [ ${element.article_code} ] - ${mrp} BDT`,
            value: element._id,
            product: element,
          });
        });
      } else {
        tempArray.push({
          label: `No products found`,
          value: `no_product`,
          isDisabled: true,
        });
      }
      callback(tempArray);
    } catch (err) {
      if (!axios.isCancel(err)) {
        console.error("Error searching product:", err);
      }
      callback([]);
    }
  };

  getValue = async (data) => {
    if (!data || data === "no_product" || data === "please select") return;
    try {
      const baseUrl = BASE_URL.endsWith("/") ? BASE_URL : `${BASE_URL}/`;
      const result = await axios.get(`${baseUrl}product/details/${data}`);
      if (result?.data) {
        this.props.addToList(result.data);
      }
    } catch (err) {
      console.error("Error fetching product details:", err);
    } finally {
      this.setState({ selectedOption: null, qString: null });
      this.selectRef.current?.focus?.();
    }
  };

  onSearchChange = (selectedOption) => {
    if (selectedOption && selectedOption.value) {
      this.setState({
        selectedOption: null,
      });
      this.getValue(selectedOption.value);
    }
  };
  handleChange = (normalSelectOption) => {
    this.setState({ normalSelectOption });
  };

  selectRef = React.createRef();

  render() {
    return (
      <AsyncSelect
        value={this.state.selectedOption}
        loadOptions={this.fetchData}
        placeholder="Product Search"
        key={this.props.warehouse || "default"}
        onChange={(e) => {
          this.onSearchChange(e);
        }}
        defaultOptions={false}
        classNamePrefix="react-select"
        innerRef={this.selectRef}
        ref={this.props.damageNewProductsRef}
        styles={customStyles}
      />
    );
  }
}

export default DamageNewProductSelect;
